import { render, staticRenderFns } from "./CheckboxList.vue?vue&type=template&id=508b7ee1&"
import script from "./CheckboxList.vue?vue&type=script&scoped=true&lang=js&"
export * from "./CheckboxList.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./CheckboxList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../NodeModules/Ljbc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports